export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/ana-bernardo-becb7cfb03dea233a37383c84d167b64.jpg";